var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-video-player',_vm._g({ref:"videoPlayer",attrs:{"options":_vm.playerOptions},on:{"ended":_vm.onPlayerEnded}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }